import { cloneDeep } from "lodash";
import { IWebsiteBuilderWebsiteVersionNavigationMenuDropdownItem, IWebsiteBuilderWebsiteVersionNavigationMenuExternalItem, IWebsiteBuilderWebsiteVersionNavigationMenuItemRaw, IWebsiteBuilderWebsiteVersionNavigationMenuPageItem, TWebsiteBuilderWebsiteVersionNavigationMenuDropdownItemChild, TWebsiteBuilderWebsiteVersionNavigationMenuItem } from "redux/reducers/models/websiteBuilder";

export function websiteBuilderBuildNavigationMenuItem(rawItem: IWebsiteBuilderWebsiteVersionNavigationMenuItemRaw, navigationMenuItems: TWebsiteBuilderWebsiteVersionNavigationMenuItem[]): TWebsiteBuilderWebsiteVersionNavigationMenuItem {
  if (rawItem.type === "page") {
    return {
      id: rawItem.id,
      website_version_id: rawItem.website_version_id,
      type: "page",
      page_id: rawItem.page_id,
      position: rawItem.position,
      parent_id: rawItem.parent_id,
      hidden: rawItem.hidden,
    };
  } else if (rawItem.type === "external") {
    return {
      id: rawItem.id,
      website_version_id: rawItem.website_version_id,
      type: "external",
      label: rawItem.label,
      external_url: rawItem.external_url,
      open_in_new_tab: rawItem.open_in_new_tab,
      position: rawItem.position,
      parent_id: rawItem.parent_id,
      hidden: rawItem.hidden,
    };
  } else if (rawItem.type === "dropdown") {
    let children: TWebsiteBuilderWebsiteVersionNavigationMenuDropdownItemChild[] = [];
    
    const originalItem = navigationMenuItems.find(item => rawItem.id === item.id);
    
    if (originalItem?.type === "dropdown") {
      children = cloneDeep(originalItem.children);
    }

    return {
      id: rawItem.id,
      website_version_id: rawItem.website_version_id,
      type: "dropdown",
      label: rawItem.label,
      position: rawItem.position,
      hidden: rawItem.hidden,
      children,
    };
  } else {
    return null;
  }
}

export function websiteBuilderBuildNavigationMenuItems(rawItems: IWebsiteBuilderWebsiteVersionNavigationMenuItemRaw[]): TWebsiteBuilderWebsiteVersionNavigationMenuItem[] {
  const dropdowns = new Map<number, IWebsiteBuilderWebsiteVersionNavigationMenuDropdownItem>();

  const rootItems: TWebsiteBuilderWebsiteVersionNavigationMenuItem[] = [];

  const sortByPosition = <T extends { position: number }>(arr: T[]) => arr.sort((a, b) => a.position - b.position);

  const convertToPage = (item: IWebsiteBuilderWebsiteVersionNavigationMenuItemRaw): IWebsiteBuilderWebsiteVersionNavigationMenuPageItem => {
    return {
      id: item.id,
      website_version_id: item.website_version_id,
      type: "page",
      page_id: item.page_id,
      position: item.position,
      parent_id: item.parent_id,
      hidden: item.hidden,
    };
  };

  const convertToExternal = (item: IWebsiteBuilderWebsiteVersionNavigationMenuItemRaw): IWebsiteBuilderWebsiteVersionNavigationMenuExternalItem => {
    return {
      id: item.id,
      website_version_id: item.website_version_id,
      type: "external",
      label: item.label,
      external_url: item.external_url,
      open_in_new_tab: item.open_in_new_tab,
      position: item.position,
      parent_id: item.parent_id,
      hidden: item.hidden,
    };
  };

  for (const item of rawItems) {
    if (item.type === "dropdown") {
      const dropdown: IWebsiteBuilderWebsiteVersionNavigationMenuDropdownItem = {
        id: item.id,
        website_version_id: item.website_version_id,
        type: "dropdown",
        label: item.label,
        position: item.position,
        hidden: item.hidden,
        children: [],
      };

      dropdowns.set(item.id, dropdown);
      rootItems.push(dropdown);
    } else if (item.parent_id == null) {
      if (item.type === "page") {
        rootItems.push(convertToPage(item));
      } else if (item.type === "external") {
        rootItems.push(convertToExternal(item));
      }
    }
  }

  for (const item of rawItems) {
    if (item.type !== "dropdown" && item.parent_id != null) {
      const dropdown = dropdowns.get(item.parent_id);

      if (dropdown != null) {
        if (item.type === "page") {
          dropdown.children.push(convertToPage(item));
        } else if (item.type === "external") {
          dropdown.children.push(convertToExternal(item));
        }
      }
    }
  }

  sortByPosition(rootItems);

  for (const dropdown of dropdowns.values()) {
    sortByPosition(dropdown.children);
  }

  return rootItems;
}